<template>
  <div class="py-4" v-if="listCareHistory && listCareHistory.length">
    <div class="font-weight-bold mb-4"> Lịch sử chăm sóc</div>
    <div v-if="listCareHistory && listCareHistory.length" id="style-2" class="history-care-content">
      <div class="d-flex align-center mb-3" v-for="careHistory in listCareHistory" :key="careHistory.id">
        <img src="../assets/green_dot.svg" height="16" width="16" alt="">
        <div class="time-box ml-2 mr-4 text-no-wrap">
          {{ formatDateCus(careHistory.created_at, 'DD/MM/YYYY - HH:mm') }}
        </div>
        <div
          :style="{'background': careHistory.backgroundColor}"
          class="subject-box mr-2 text-no-wrap">
          {{ careHistory.name }}
        </div>
        <div>
          <span :style="{ 'font-weight': 'bold', 'color': careHistory.color }">{{ careHistory.callAndCallStatus }}</span> | {{ careHistory.note }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CareHistoryTab',
  props: {
    listCareHistory: {
      type: Array,
      default: () => ([{
        createdAt: '2023-10-03 09:30',
        name: 'Blended vhs - HangPT1',
        callAndCallStatus: 'CSĐK - C3 - Gọi lại',
        note: 'Mẹ hẹn gọi lại sau vào 9:00 AM ngày 27/9/2023',
        color: '#27C100',
      }]),
    },
  },
  data() {
    return {};
  },
  methods: {},
  computed: {},
};
</script>

<style scoped>
.time-box {
  background: #F6F7F9;
  border-radius: 5px;
  padding: 4px 10px;
  margin-left: 10px;
  color: #52526C;
  font-size: 14px;
  font-weight: bold;
}
.subject-box {
  border-radius: 4px;
  padding: 4px 5px;
  color: white;
  font-size: 12px;
  font-weight: bold;
}
.history-care-content {
  min-height: 250px;
  max-height: 280px;
  overflow-y: auto;
}
@media screen and (max-width: 1440px) {
 .time-box {
  font-size: 12px !important;
 }
}
</style>
